// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Chivo:wght@400;600;700;900&family=IBM+Plex+Sans:wght@400;500;600&family=IBM+Plex+Mono:wght@400;500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg-page: #F8F9FA;
  --bg-surface: #FFFFFF;
  --bg-surface-alt: #F3F4F6;
  --bg-table-stripe: #FAFAFB;
  --border-default: #E2E4E8;
  --border-strong: #D1D5DB;
  --border-focus: #0F52BA;
  --text-primary: #0F1115;
  --text-secondary: #525866;
  --text-tertiary: #868C98;
  --text-inverse: #FFFFFF;
  --brand-primary: #0047AB;
  --brand-primary-hover: #003380;
  --brand-primary-active: #002255;
  --brand-subtle: #E5F0FF;
}

body {
  font-family: 'IBM Plex Sans', -apple-system, sans-serif;
  background-color: var(--bg-page);
  color: var(--text-primary);
  font-size: 14px;
  line-height: 1.4;
}

h1, h2, h3, h4, h5, h6 {
  font-family: 'Chivo', sans-serif;
  font-weight: 700;
}

.font-mono {
  font-family: 'IBM Plex Mono', monospace;
}

.App {
  min-height: 100vh;
}

/* Data table styles */
table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

table th {
  background-color: var(--bg-surface-alt);
  font-weight: 600;
  text-align: left;
  padding: 8px 12px;
  border-bottom: 1px solid var(--border-strong);
  position: sticky;
  top: 0;
  z-index: 10;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-secondary);
}

table td {
  padding: 8px 12px;
  border-bottom: 1px solid var(--border-default);
}

table tbody tr:nth-child(even) {
  background-color: var(--bg-table-stripe);
}

table tbody tr:hover {
  background-color: var(--bg-surface-alt);
}

.text-right {
  text-align: right;
}

.tabular-nums {
  font-variant-numeric: tabular-nums;
  font-family: 'IBM Plex Mono', monospace;
}

/* Badge styles */
.badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  border: 1px solid;
}

.badge-success {
  background-color: #D1FAE5;
  color: #065F46;
  border-color: #34D399;
}

.badge-warning {
  background-color: #FEF3C7;
  color: #92400E;
  border-color: #FBBF24;
}

.badge-danger {
  background-color: #FEE2E2;
  color: #991B1B;
  border-color: #F87171;
}

.badge-info {
  background-color: #DBEAFE;
  color: #1E40AF;
  border-color: #60A5FA;
}

/* Button styles */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 4px;
  border: 1px solid transparent;
  cursor: pointer;
  transition: background-color 150ms ease, border-color 150ms ease;
  text-decoration: none;
  gap: 6px;
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-primary {
  background-color: var(--brand-primary);
  color: var(--text-inverse);
}

.btn-primary:hover:not(:disabled) {
  background-color: var(--brand-primary-hover);
}

.btn-secondary {
  background-color: var(--bg-surface);
  color: var(--text-primary);
  border-color: var(--border-strong);
}

.btn-secondary:hover:not(:disabled) {
  background-color: var(--bg-surface-alt);
}

.btn-danger {
  background-color: #DC2626;
  color: var(--text-inverse);
}

.btn-danger:hover:not(:disabled) {
  background-color: #B91C1C;
}

.btn-ghost {
  background-color: transparent;
  color: var(--text-secondary);
}

.btn-ghost:hover:not(:disabled) {
  background-color: var(--bg-surface-alt);
}

.btn-sm {
  padding: 4px 10px;
  font-size: 12px;
}

/* Form styles */
.form-group {
  margin-bottom: 16px;
}

.form-label {
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: var(--text-secondary);
  margin-bottom: 4px;
}

.form-input,
.form-select,
.form-textarea {
  width: 100%;
  padding: 8px 12px;
  font-size: 14px;
  border: 1px solid var(--border-default);
  border-radius: 4px;
  background-color: var(--bg-surface);
  color: var(--text-primary);
  transition: border-color 150ms ease;
}

.form-input:focus,
.form-select:focus,
.form-textarea:focus {
  outline: none;
  border-color: var(--border-focus);
  box-shadow: 0 0 0 3px rgba(15, 82, 186, 0.1);
}

.form-textarea {
  resize: vertical;
  min-height: 80px;
}

/* Card styles */
.card {
  background-color: var(--bg-surface);
  border: 1px solid var(--border-default);
  border-radius: 4px;
  padding: 20px;
}

.card-header {
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border-default);
}

.card-title {
  font-size: 16px;
  font-weight: 700;
  margin: 0;
}

/* Grid layout */
.grid {
  display: grid;
  gap: 16px;
}

.grid-cols-2 {
  grid-template-columns: repeat(2, 1fr);
}

.grid-cols-3 {
  grid-template-columns: repeat(3, 1fr);
}

.grid-cols-4 {
  grid-template-columns: repeat(4, 1fr);
}

@media (max-width: 768px) {
  .grid-cols-2,
  .grid-cols-3,
  .grid-cols-4 {
    grid-template-columns: 1fr;
  }
}

/* Utility classes */
.text-sm {
  font-size: 13px;
}

.text-xs {
  font-size: 11px;
}

.font-semibold {
  font-weight: 600;
}

.font-bold {
  font-weight: 700;
}

.text-gray {
  color: var(--text-secondary);
}

.text-muted {
  color: var(--text-tertiary);
}

.flex {
  display: flex;
}

.items-center {
  align-items: center;
}

.justify-between {
  justify-content: space-between;
}

.gap-2 {
  gap: 8px;
}

.gap-4 {
  gap: 16px;
}

.mb-4 {
  margin-bottom: 16px;
}

.mt-4 {
  margin-top: 16px;
}

.p-4 {
  padding: 16px;
}

/* Table container with scroll */
.table-container {
  overflow-x: auto;
  border: 1px solid var(--border-default);
  border-radius: 4px;
}

/* Sidebar */
.sidebar {
  width: 240px;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background-color: var(--bg-surface);
  border-right: 1px solid var(--border-default);
  overflow-y: auto;
}

.sidebar-nav {
  padding: 16px 0;
}

.sidebar-nav-item {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  color: var(--text-primary);
  text-decoration: none;
  font-size: 14px;
  transition: background-color 150ms ease;
  gap: 10px;
}

.sidebar-nav-item:hover {
  background-color: var(--bg-surface-alt);
}

.sidebar-nav-item.active {
  background-color: var(--brand-subtle);
  color: var(--brand-primary);
  font-weight: 600;
}

/* Main content area */
.main-content {
  margin-left: 240px;
  min-height: 100vh;
}

.top-header {
  height: 56px;
  background-color: var(--bg-surface);
  border-bottom: 1px solid var(--border-default);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  position: sticky;
  top: 0;
  z-index: 40;
}

.content-area {
  padding: 24px;
  max-width: 1600px;
}

/* Modal overlay */
.modal-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(15, 17, 21, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
}

.modal-content {
  background-color: var(--bg-surface);
  border-radius: 4px;
  max-width: 600px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
}

.modal-header {
  padding: 20px;
  border-bottom: 1px solid var(--border-default);
}

.modal-body {
  padding: 20px;
}

.modal-footer {
  padding: 20px;
  border-top: 1px solid var(--border-default);
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

/* Stats card */
.stat-card {
  background-color: var(--bg-surface);
  border: 1px solid var(--border-default);
  border-radius: 4px;
  padding: 16px;
}

.stat-value {
  font-size: 28px;
  font-weight: 700;
  font-family: 'Chivo', sans-serif;
  color: var(--text-primary);
}

.stat-label {
  font-size: 12px;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-top: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,uDAAuD;EACvD,gCAAgC;EAChC,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,6CAA6C;EAC7C,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;AACzC;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,gEAAgE;EAChE,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,uCAAuC;EACvC,kBAAkB;EAClB,mCAAmC;EACnC,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;;;EAGE,aAAa;EACb,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,mCAAmC;EACnC,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;;;IAGE,0BAA0B;EAC5B;AACF;;AAEA,oBAAoB;AACpB;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,OAAO;EACP,MAAM;EACN,mCAAmC;EACnC,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,qBAAqB;EACrB,eAAe;EACf,uCAAuC;EACvC,SAAS;AACX;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,8CAA8C;EAC9C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,QAAQ;EACR,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA,eAAe;AACf;EACE,mCAAmC;EACnC,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Chivo:wght@400;600;700;900&family=IBM+Plex+Sans:wght@400;500;600&family=IBM+Plex+Mono:wght@400;500&display=swap');\n\n:root {\n  --bg-page: #F8F9FA;\n  --bg-surface: #FFFFFF;\n  --bg-surface-alt: #F3F4F6;\n  --bg-table-stripe: #FAFAFB;\n  --border-default: #E2E4E8;\n  --border-strong: #D1D5DB;\n  --border-focus: #0F52BA;\n  --text-primary: #0F1115;\n  --text-secondary: #525866;\n  --text-tertiary: #868C98;\n  --text-inverse: #FFFFFF;\n  --brand-primary: #0047AB;\n  --brand-primary-hover: #003380;\n  --brand-primary-active: #002255;\n  --brand-subtle: #E5F0FF;\n}\n\nbody {\n  font-family: 'IBM Plex Sans', -apple-system, sans-serif;\n  background-color: var(--bg-page);\n  color: var(--text-primary);\n  font-size: 14px;\n  line-height: 1.4;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-family: 'Chivo', sans-serif;\n  font-weight: 700;\n}\n\n.font-mono {\n  font-family: 'IBM Plex Mono', monospace;\n}\n\n.App {\n  min-height: 100vh;\n}\n\n/* Data table styles */\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\ntable th {\n  background-color: var(--bg-surface-alt);\n  font-weight: 600;\n  text-align: left;\n  padding: 8px 12px;\n  border-bottom: 1px solid var(--border-strong);\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--text-secondary);\n}\n\ntable td {\n  padding: 8px 12px;\n  border-bottom: 1px solid var(--border-default);\n}\n\ntable tbody tr:nth-child(even) {\n  background-color: var(--bg-table-stripe);\n}\n\ntable tbody tr:hover {\n  background-color: var(--bg-surface-alt);\n}\n\n.text-right {\n  text-align: right;\n}\n\n.tabular-nums {\n  font-variant-numeric: tabular-nums;\n  font-family: 'IBM Plex Mono', monospace;\n}\n\n/* Badge styles */\n.badge {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 500;\n  border: 1px solid;\n}\n\n.badge-success {\n  background-color: #D1FAE5;\n  color: #065F46;\n  border-color: #34D399;\n}\n\n.badge-warning {\n  background-color: #FEF3C7;\n  color: #92400E;\n  border-color: #FBBF24;\n}\n\n.badge-danger {\n  background-color: #FEE2E2;\n  color: #991B1B;\n  border-color: #F87171;\n}\n\n.badge-info {\n  background-color: #DBEAFE;\n  color: #1E40AF;\n  border-color: #60A5FA;\n}\n\n/* Button styles */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 16px;\n  font-size: 14px;\n  font-weight: 500;\n  border-radius: 4px;\n  border: 1px solid transparent;\n  cursor: pointer;\n  transition: background-color 150ms ease, border-color 150ms ease;\n  text-decoration: none;\n  gap: 6px;\n}\n\n.btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn-primary {\n  background-color: var(--brand-primary);\n  color: var(--text-inverse);\n}\n\n.btn-primary:hover:not(:disabled) {\n  background-color: var(--brand-primary-hover);\n}\n\n.btn-secondary {\n  background-color: var(--bg-surface);\n  color: var(--text-primary);\n  border-color: var(--border-strong);\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background-color: var(--bg-surface-alt);\n}\n\n.btn-danger {\n  background-color: #DC2626;\n  color: var(--text-inverse);\n}\n\n.btn-danger:hover:not(:disabled) {\n  background-color: #B91C1C;\n}\n\n.btn-ghost {\n  background-color: transparent;\n  color: var(--text-secondary);\n}\n\n.btn-ghost:hover:not(:disabled) {\n  background-color: var(--bg-surface-alt);\n}\n\n.btn-sm {\n  padding: 4px 10px;\n  font-size: 12px;\n}\n\n/* Form styles */\n.form-group {\n  margin-bottom: 16px;\n}\n\n.form-label {\n  display: block;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--text-secondary);\n  margin-bottom: 4px;\n}\n\n.form-input,\n.form-select,\n.form-textarea {\n  width: 100%;\n  padding: 8px 12px;\n  font-size: 14px;\n  border: 1px solid var(--border-default);\n  border-radius: 4px;\n  background-color: var(--bg-surface);\n  color: var(--text-primary);\n  transition: border-color 150ms ease;\n}\n\n.form-input:focus,\n.form-select:focus,\n.form-textarea:focus {\n  outline: none;\n  border-color: var(--border-focus);\n  box-shadow: 0 0 0 3px rgba(15, 82, 186, 0.1);\n}\n\n.form-textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n/* Card styles */\n.card {\n  background-color: var(--bg-surface);\n  border: 1px solid var(--border-default);\n  border-radius: 4px;\n  padding: 20px;\n}\n\n.card-header {\n  margin-bottom: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--border-default);\n}\n\n.card-title {\n  font-size: 16px;\n  font-weight: 700;\n  margin: 0;\n}\n\n/* Grid layout */\n.grid {\n  display: grid;\n  gap: 16px;\n}\n\n.grid-cols-2 {\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.grid-cols-3 {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.grid-cols-4 {\n  grid-template-columns: repeat(4, 1fr);\n}\n\n@media (max-width: 768px) {\n  .grid-cols-2,\n  .grid-cols-3,\n  .grid-cols-4 {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Utility classes */\n.text-sm {\n  font-size: 13px;\n}\n\n.text-xs {\n  font-size: 11px;\n}\n\n.font-semibold {\n  font-weight: 600;\n}\n\n.font-bold {\n  font-weight: 700;\n}\n\n.text-gray {\n  color: var(--text-secondary);\n}\n\n.text-muted {\n  color: var(--text-tertiary);\n}\n\n.flex {\n  display: flex;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.justify-between {\n  justify-content: space-between;\n}\n\n.gap-2 {\n  gap: 8px;\n}\n\n.gap-4 {\n  gap: 16px;\n}\n\n.mb-4 {\n  margin-bottom: 16px;\n}\n\n.mt-4 {\n  margin-top: 16px;\n}\n\n.p-4 {\n  padding: 16px;\n}\n\n/* Table container with scroll */\n.table-container {\n  overflow-x: auto;\n  border: 1px solid var(--border-default);\n  border-radius: 4px;\n}\n\n/* Sidebar */\n.sidebar {\n  width: 240px;\n  height: 100vh;\n  position: fixed;\n  left: 0;\n  top: 0;\n  background-color: var(--bg-surface);\n  border-right: 1px solid var(--border-default);\n  overflow-y: auto;\n}\n\n.sidebar-nav {\n  padding: 16px 0;\n}\n\n.sidebar-nav-item {\n  display: flex;\n  align-items: center;\n  padding: 10px 20px;\n  color: var(--text-primary);\n  text-decoration: none;\n  font-size: 14px;\n  transition: background-color 150ms ease;\n  gap: 10px;\n}\n\n.sidebar-nav-item:hover {\n  background-color: var(--bg-surface-alt);\n}\n\n.sidebar-nav-item.active {\n  background-color: var(--brand-subtle);\n  color: var(--brand-primary);\n  font-weight: 600;\n}\n\n/* Main content area */\n.main-content {\n  margin-left: 240px;\n  min-height: 100vh;\n}\n\n.top-header {\n  height: 56px;\n  background-color: var(--bg-surface);\n  border-bottom: 1px solid var(--border-default);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 24px;\n  position: sticky;\n  top: 0;\n  z-index: 40;\n}\n\n.content-area {\n  padding: 24px;\n  max-width: 1600px;\n}\n\n/* Modal overlay */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(15, 17, 21, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 50;\n}\n\n.modal-content {\n  background-color: var(--bg-surface);\n  border-radius: 4px;\n  max-width: 600px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);\n}\n\n.modal-header {\n  padding: 20px;\n  border-bottom: 1px solid var(--border-default);\n}\n\n.modal-body {\n  padding: 20px;\n}\n\n.modal-footer {\n  padding: 20px;\n  border-top: 1px solid var(--border-default);\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n/* Stats card */\n.stat-card {\n  background-color: var(--bg-surface);\n  border: 1px solid var(--border-default);\n  border-radius: 4px;\n  padding: 16px;\n}\n\n.stat-value {\n  font-size: 28px;\n  font-weight: 700;\n  font-family: 'Chivo', sans-serif;\n  color: var(--text-primary);\n}\n\n.stat-label {\n  font-size: 12px;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-top: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
